import SatisfactionQuestion from './SatisfactionQuestion';
import ImpactFactors from './ImpactFactors/ImpactFactors';
import ImpactFactorDetails from './ImpactFactorDetails';
import TextQuestion from './TextQuestion';
import LikertQuestion from './LikertQuestion';

export const SESSION_STORAGE_KEY = 'RaiseMe:Survey';

export const STEP_COMPONENTS = {
  satisfaction: SatisfactionQuestion,
  factors: ImpactFactors,
  'additional-info': ImpactFactorDetails,
  text: TextQuestion,
  likert: LikertQuestion,
};

export const STEPS = {
  'Survey::SatisfactionQuestion': () => ['satisfaction'],
  'Survey::LikertQuestion': () => ['likert'],
  'Survey::ImpactFactorQuestion': (question) => {
    const steps = ['factors'];

    if (question.hasAdditionalInfo) {
      steps.push('additional-info');
    }

    return steps;
  },
  'Survey::TextQuestion': () => ['text'],
};
